var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotoutlinedFilltick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34488 12.1854L8.57541 15.81C8.83927 16.2388 9.30668 16.5 9.81013 16.5C10.6987 16.5 11.3782 15.708 11.243 14.8298L11 13.25C10.7371 11.5411 12.0593 10 13.7882 10H14.478C17.015 10 18.6651 7.33013 17.5305 5.06096L16.382 2.76394C15.535 1.07001 13.8037 0 11.9098 0H9C7.65211 0 6.45994 0.666689 5.73525 1.6883C5.74501 1.79088 5.75 1.89486 5.75 2V10C5.75 10.331 5.70052 10.6504 5.60855 10.9513C5.78577 11.2769 6.02173 11.6603 6.34488 12.1854Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 2C4.25 1.0335 3.4665 0.25 2.5 0.25C1.5335 0.25 0.75 1.0335 0.75 2V10C0.75 10.9665 1.5335 11.75 2.5 11.75C3.4665 11.75 4.25 10.9665 4.25 10V2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotoutlinedFilltick);
export default __webpack_public_path__ + "static/media/notoutlined_filltick.dce1d4c8fded89e485f6eec817cf40ad.svg";
export { ForwardRef as ReactComponent };